import SectionHeading from '@/components/base/SectionHeading';
import Reveal from '@/components/base/Reveal';
import { lifecycle, lifecycleSummary } from '@/mocks/smart-farm';

export default function BusinessLoop() {
  return (
    <section className="w-full px-4 md:px-6 py-16 md:py-24 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <SectionHeading
          eyebrow="业务闭环"
          title="从经验种植到数据经营"
          subtitle="五个阶段逐步在线，让数据贯穿生产到经营，形成持续迭代的闭环。"
        />

        <Reveal className="mt-12">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-5">
            {lifecycle.map((step, idx) => (
              <div key={step.no} className="relative">
                <div className="flex items-center gap-3">
                  <div
                    className={`w-10 h-10 flex items-center justify-center rounded-full text-sm font-bold text-foreground-950 shrink-0 ${
                      idx === 0
                        ? 'bg-accent-300'
                        : idx === 1
                          ? 'bg-accent-400'
                          : idx === 2
                            ? 'bg-primary-300'
                            : idx === 3
                              ? 'bg-primary-400'
                              : 'bg-primary-500'
                    }`}
                  >
                    {step.no}
                  </div>
                  {idx < lifecycle.length - 1 && (
                    <div className="hidden lg:block flex-1 h-px bg-foreground-200"></div>
                  )}
                </div>
                <div className="mt-4 font-heading font-bold text-foreground-950 text-lg">{step.title}</div>
                <p className="mt-2 text-sm text-foreground-600 leading-relaxed">{step.desc}</p>
              </div>
            ))}
          </div>
        </Reveal>

        {/* 数据回流提示 */}
        <Reveal className="mt-10" delay={120}>
          <div className="flex items-center justify-center gap-3 p-5 rounded-lg bg-background-50 border border-accent-200">
            <div className="w-8 h-8 flex items-center justify-center rounded-full bg-accent-500 text-foreground-950 shrink-0">
              <i className="ri-refresh-line text-lg"></i>
            </div>
            <p className="text-sm md:text-base text-foreground-800 leading-relaxed">
              {lifecycleSummary}
            </p>
          </div>
        </Reveal>
      </div>
    </section>
  );
}